// eslint-disable-next-line @nx/enforce-module-boundaries
import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Typography } from '@occc-app/design-system';

import { dataKeyToLabelMap } from './metrics-chart.constants';
import { MetricsChartDataKey } from './metrics-chart.types';

export const xAxisTickFormatter = (value: Date) => formatDateTime(value, DateTimeFormat.Date);

export const tooltipFormatter = (value: number, name: MetricsChartDataKey) => [
  value,
  dataKeyToLabelMap[name],
];

export const tooltipLabelFormatter = (value: Date) =>
  formatDateTime(value, DateTimeFormat.DateWithYear);

export const legendFormatter = (value: MetricsChartDataKey) => (
  <Typography variant='caption' color='textSecondary' fontWeight='normal'>
    {dataKeyToLabelMap[value]}
  </Typography>
);
